import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
  // Auth is handled entirely via the httpOnly `access_token` cookie set by the
  // backend on /auth/login. We intentionally do NOT persist the JWT in
  // localStorage/sessionStorage — that is vulnerable to XSS token theft.
  withCredentials: true,
});

// ----- Public -----
export const fetchProjects = async () => {
  const { data } = await api.get("/projects");
  return data;
};

export const fetchProject = async (id) => {
  const { data } = await api.get(`/projects/${id}`);
  return data;
};

export const fetchReignVillaDetails = async () => {
  const { data } = await api.get("/projects/reign-villa-resorts/details");
  return data;
};

// Legacy alias
export const fetchStLuciaLots = fetchReignVillaDetails;

export const submitConsultation = async (payload) => {
  const { data } = await api.post("/consultations", payload);
  return data;
};

export const requestPitchDeck = async (payload) => {
  const { data } = await api.post("/pitch-deck/request", payload);
  return data;
};

export const submitInvestorInquiry = async (payload) => {
  const { data } = await api.post("/investor-inquiries", payload);
  return data;
};

export const fetchInvestorInquiries = async () => {
  const { data } = await api.get("/investor-inquiries");
  return data;
};

export const joinVillaWaitlist = async (payload) => {
  const { data } = await api.post("/villa-waitlist", payload);
  return data;
};

export const fetchVillaWaitlist = async () => {
  const { data } = await api.get("/villa-waitlist");
  return data;
};

export const pitchDeckDownloadUrl = `${API}/pitch-deck/download`;

// ----- Auth -----
export const login = async ({ email, password }) => {
  // Backend sets an httpOnly `access_token` cookie. We do not store the JWT
  // client-side — the cookie is the source of truth for subsequent requests.
  const { data } = await api.post("/auth/login", { email, password });
  return data;
};

export const logout = async () => {
  // Silently ignore network errors — the caller clears client-side state anyway.
  try {
    await api.post("/auth/logout");
  } catch {
    /* no-op: logout is best-effort */
  }
};

export const fetchMe = async () => {
  const { data } = await api.get("/auth/me");
  return data;
};

// ----- Admin -----
export const fetchConsultations = async () => {
  const { data } = await api.get("/consultations");
  return data;
};

export const updateConsultationStatus = async (id, status) => {
  const { data } = await api.patch(`/consultations/${id}/status`, { status });
  return data;
};

export const deleteConsultation = async (id) => {
  const { data } = await api.delete(`/consultations/${id}`);
  return data;
};

export const fetchPitchLeads = async () => {
  const { data } = await api.get("/pitch-deck/leads");
  return data;
};

export const consultationsCsvUrl = `${API}/consultations/export.csv`;

export const formatApiError = (err, fallback = "Something went wrong. Please try again.") => {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return fallback;
};
